import { action, computed, observable } from 'mobx'

const _SNACK_TYPE_INFO = 'info'
type SnackTypeInfo = typeof _SNACK_TYPE_INFO

const SNACK_TYPE_ERROR = 'error'
type SnackTypeError = typeof SNACK_TYPE_ERROR

const SNACK_TYPE_SUCCESS = 'success'
type SnackTypeSuccess = typeof SNACK_TYPE_SUCCESS

type TSnackType = SnackTypeInfo | SnackTypeError | SnackTypeSuccess

interface ISnack {
  message: string
  type?: TSnackType
  actionLink?: string
  actionLabel?: string
}

export class SnackService {
  private delay = 250
  private scheduled: number | undefined // timeout

  @observable
  private curr: ISnack | null = null

  @observable
  private next: ISnack | null = null

  private _isActive: boolean = false

  get isActive(): boolean {
    return this._isActive
  }

  @computed
  get current(): ISnack | null {
    return this.curr
  }

  @action
  notifySuccess(message: string) {
    this.addSnack({ message, type: SNACK_TYPE_SUCCESS })
  }

  @action
  notifyError(message: string) {
    this.addSnack({ message, type: SNACK_TYPE_ERROR })
  }

  @action
  addSnack(snack: ISnack | string) {
    this.next = typeof snack === 'string' ? { message: snack } : snack

    if (this.curr) {
      this._isActive = false
      setTimeout(() => {
        this.swapSnack()
      }, this.delay)
    } else {
      this.swapSnack()
    }
  }

  @action
  hideSnack = () => {
    this.curr = null
  }

  @action
  private swapSnack() {
    clearTimeout(this.scheduled)

    if (!this.next) {
      this._isActive = false
      this.curr = null
    } else {
      this.curr = this.next
      this._isActive = true
      this.next = null

      this.scheduled = window.setTimeout(() => {
        this._isActive = false
        setTimeout(() => {
          this.swapSnack()
        }, this.delay)
      }, 5000)
    }
  }
}
